// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"55e211c3","787":"15230f2c"}[chunkId] + ".chunk.js";
};